import { Outlet } from 'react-router-dom';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { SmartAppBanner } from '../home/SmartAppBanner';
import { Nav } from './Nav';
import { Footer } from './Footer';

export function Shell() {
  usePageAnalytics();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SmartAppBanner />
      <Nav />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
